import React from 'react';

const BannerSection = ({ country , cardStyles }) => {

 

  const mergedStyles = {
    ...styles.bannerSection,
    ...cardStyles, 
    
  };


  return (
    <div style={mergedStyles}>
      <img src={country?.flag_image} alt={`${country?.country_name} flag`} style={styles.flag} />
      <span style={styles.countryName}>{country?.country_name}</span>
    </div>
  );
};

// Define enhanced and attractive styles for the banner
const styles = {
  
  bannerSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fff', 
    padding: '20px 30px',
    borderRadius: '12px',
    // boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)', 
    maxWidth: '450px',
    margin: '20px auto',
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out', 
  },
  bannerSectionHover: {
    transform: 'scale(1.05)', 
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
  },
  flag: {
    width: '60px', 
    height: '40px',
    marginRight: '15px',
    borderRadius: '5px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    transition: 'transform 0.3s ease-in-out', 
  },
  countryName: {
    fontSize: '24px', 
    fontWeight: '700',
    color: '#fff', 
    letterSpacing: '1px', 
    textShadow: '1px 1px 4px rgba(0, 0, 0, 0.3)', 
    transition: 'color 0.3s ease-in-out', 
  },
  hoverEffect: {
    color: '#ffdc00', 
  },
};

export default BannerSection;
